import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  institutionCard: {
    '& .ant-card-body': {
      paddingBlock: '8px 24px'
    }
  },
  laboratoryLoading: {
    height: '290px'
  }
}))
